export default () => ({
	legacy: false,
	fallbackLocale: "en-gb"
});
